import { inject, Injectable, Renderer2, RendererFactory2, Signal } from '@angular/core';
import { DefaultLangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { firstValueFrom, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
	providedIn: 'root'
})
export class LibSharedService {
	private readonly translate = inject(TranslateService);
	private readonly document = inject(DOCUMENT);

	private renderer: Renderer2;

	constructor(private rendererFactory: RendererFactory2) {
		this.renderer = this.rendererFactory.createRenderer(null, null);
	}

	// Add PRECONNECT to speed up the page load time.
	appendPreconnectToHead() {
		if (!window) {
			return;
		}

		if (window.location.hostname === 'localhost') {
			return;
		}

		const link = this.renderer.createElement('link');
		this.renderer.setAttribute(link, 'rel', 'preconnect');
		const currentDomainWithProtocol = window.location.protocol + '//' + window.location.hostname;

		this.renderer.setAttribute(link, 'href', currentDomainWithProtocol);

		const head = this.renderer.selectRootElement('head', true);
		this.renderer.appendChild(head, link);
	}

	// ----- Language Management -----------------------------------------------------------------------------------------

	// Richtet alle Übersetzungen für die App ein und liefert ein Promise für den "provideAppInitializer".
	translationInit(languages: string[]) {
		languages = Array.isArray(languages) ? languages : ['de'];

		// Wenn der Pfad eine definierte Sprache enthält, wird die sofort eingestellt.
		const path = this.document.location.pathname || '/';
		const languageByPath = path.split('/')[1];

		const currentLanguage = languages.includes(languageByPath) ? languageByPath : languages[0];

		console.log('App language INIT', currentLanguage);

		this.translate.addLangs(languages);
		this.translate.setDefaultLang(currentLanguage);

		return firstValueFrom(this.translate.use(currentLanguage));
	}

	// prettier-ignore
	getCurrentLanguage: Signal<string> = toSignal(
		this.translate.onLangChange.pipe(
			map((event) => event.lang)
		), { initialValue: this.translate.currentLang || this.translate.getDefaultLang() || 'de' }
	);

	// prettier-ignore
	getDefaultLanguage: Signal<string> = toSignal(
		this.translate.onDefaultLangChange.pipe(
			map((event: DefaultLangChangeEvent) => event.lang)
		), { initialValue: this.translate.getDefaultLang() }
	);

	// prettier-ignore
	setLanguage(lang: string) {
		lang = this.translate.langs.includes(lang) ? lang : this.translate.getDefaultLang();
		// console.log('SharedService setLanguage', lang);
		this.translate.use(lang);
	}
}
